import { Component, OnInit } from '@angular/core';
import { UtilidadesService } from '../../utilidades/utilidades.servicios.index';
import { CarritoDeComprasService } from '../../Servicios/carrito-de-compras.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MensajesService } from '../../Servicios/mensajes.service';
import { AppSettingsModel } from 'src/app/Modelo/AppSettings.Model';
import { SettingsService } from 'src/app/servicios/settings.service';

@Component({
    selector: 'app-carrito-de-compras',
    templateUrl: './carrito-de-compras.component.html',
    styleUrls: [ './carrito-de-compras.component.scss' ],
})
export class CarritoDeComprasComponent implements OnInit {    
    appSettings: AppSettingsModel;

    constructor(
        public Utilidades: UtilidadesService,
        public CarritoDeCompras: CarritoDeComprasService,
        private Mensajes: MensajesService,
        private _appSettingsService: SettingsService
    ) {
        this.Utilidades._menuAbierto = false;
    }

    ngOnInit(): void {
        this._appSettingsService.get().then((appSettings: AppSettingsModel) => this.appSettings = appSettings);
    }

    public Cancelar(): void {
        this.Utilidades.CuadroDeConfirmacion("Atención!", "¿Está seguro que desea descartar el carrito?", () => {
            this.CarritoDeCompras.Vaciar();
            this.Utilidades.Navegar(['/Inicio']);
        }, null, "Sí", "No");
	}

    public Guardar(): void {
        this.Utilidades.CuadroDeConfirmacion("Atención!", "¿Desea enviar el carrito de compras?", () => {
            this.Mensajes.Nuevo(this.CarritoDeCompras.Mensaje).subscribe(() => {
                this.Utilidades.CuadroDeMensaje("Atención", ["Su consulta ha sido enviada correctamente."], () => {
                    this.CarritoDeCompras.Vaciar();
                    this.Utilidades.Navegar(['/Inicio']);
                });
            });
        }, null, "Sí", "No");
    }

    public Quitar(indice: number): void {
        this.CarritoDeCompras.QuitarProducto(indice);
    }

    public onCaptchaResolved(respuestaCaptcha: string): void {
        this.CarritoDeCompras.Mensaje.Captcha = respuestaCaptcha;
	}
}